/**
 * @module company.transformer
 */
import { timezonesFrom } from './timezone.transformer';
import { defaultLang } from '~/config/settings/app.settings';

const supportedLanguagesFrom = (languages = []) => {
  // Default lang is always supported.
  if (!Array.isArray(languages) || languages.length === 0) {
    return [defaultLang];
  }

  // @ts-expect-error TS(2339): Property 'langISOCode' does not exist on type 'nev... Remove this comment to see the full error message
  const supportedLanguages = languages.map((language) => language.langISOCode);

  return supportedLanguages;
};

const supportedLanguageIdsFrom = (languages = []) => {
  const EN_CA_ID = 1;

  // Default lang is always supported.
  if (!Array.isArray(languages) || languages.length === 0) {
    return [EN_CA_ID]; // TODO: handle this more dynamically without hardcoded value.
  }

  // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
  return languages.map((language) => language.id);
};

/**
 * Create "company" entities for the front-end, appending virtual values that
 * can be calculated up-front, here.
 *
 * @example company (from server)
 * {
 *   id: 1,
 *   name: "WorkTango",
 *   logoFileName: "https://some.place.com/image.png",
 *   topbarHexColor: "#0783b6",
 *   preferredLangauge: {
 *     id: 1,
 *     langISOCode: "en-ca"
 *   },
 *   preferredTimezone: {
 *     id: 13,
 *     timezone: "America/Toronto"
 *   },
 *   timezones: [
 *     {
 *       "id": 5,
 *       "timezone": "America/Vancouver"
 *     },
 *     {
 *       "id": 30,
 *       "timezone": "Europe/Berlin"
 *     }
 *   ]
 *   languages: [
 *     {
 *       id: 1,
 *       langISOCode: "en-ca"
 *     },
 *     {
 *       id: 2,
 *       langISOCode: "fr-ca"
 *     }
 *   ],
 *   enabledEmployeesCount: 50,
 *   completedSurveysCount: 123,
 *   inProgressSurveysCount: 1,
 *   created: "1612179443000",
 *   updated: "1613506735000"
 * }
 *
 * @example kioskConfig (from server)
 * {
 *   id: 4
 *   kioskAttributeId: '88',
 *   kioskAttributes: [
 *     {
 *       id: 123,
 *       name: 'Employee Id'
 *     }
 *   ],
 *   kioskId: 'ccae6687-0ef6-4e35-ad03-3fb2500f5e56',
 *   kioskSubdomain: 'worktangoqa'
 * }
 */
const companyFrom = (company = {}) => {
  const transformedCompany = {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    id: Number(company.id),
    // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
    name: company.name,
    // @ts-expect-error TS(2339): Property 'workspace' does not exist on type '{}'.
    workspace: company.workspace,
    // @ts-expect-error TS(2339): Property 'preferredLanguage' does not exist on typ... Remove this comment to see the full error message
    lang: company.preferredLanguage?.langISOCode,
    // @ts-expect-error TS(2339): Property 'preferredLanguage' does not exist on typ... Remove this comment to see the full error message
    languageId: company.preferredLanguage ? Number(company.preferredLanguage?.id) : undefined,
    // @ts-expect-error TS(2339): Property 'preferredTimezone' does not exist on typ... Remove this comment to see the full error message
    timezone: company.preferredTimezone?.timezone,
    // @ts-expect-error TS(2339): Property 'preferredTimezone' does not exist on typ... Remove this comment to see the full error message
    timezoneId: company.preferredTimezone?.id,
    // @ts-expect-error TS(2339): Property 'timezones' does not exist on type '{}'.
    timezones: company.timezones ? timezonesFrom(company.timezones) : undefined,
    // @ts-expect-error TS(2339): Property 'topbarColorHex' does not exist on type '... Remove this comment to see the full error message
    color: company.topbarColorHex,

    salesforceId: company.salesforceId,

    // @ts-expect-error TS(2339): Property 'logoFileName' does not exist on type '{}... Remove this comment to see the full error message
    logoUrl: company.logoFileName,
    // @ts-expect-error TS(2339): Property 'languageIds' does not exist on type '{}'... Remove this comment to see the full error message
    languages: company.languageIds || supportedLanguageIdsFrom(company.languages), // TODO: refactor backend to always return languageIds (currently not guaranteed)
    // @ts-expect-error TS(2339): Property 'supportedLanguages' does not exist on ty... Remove this comment to see the full error message
    supportedLanguages: company.supportedLanguages || supportedLanguagesFrom(company.languages),
    // @ts-expect-error TS(2339): Property 'kioskId' does not exist on type '{}'.
    kioskId: company.kioskId,
    // @ts-expect-error TS(2339): Property 'kioskAttributeId' does not exist on type... Remove this comment to see the full error message
    kioskAttributeId: Number(company.kioskAttributeId),
    // @ts-expect-error TS(2339): Property 'kioskSubdomain' does not exist on type '... Remove this comment to see the full error message
    kioskSubdomain: company.kioskSubdomain,
    // @ts-expect-error TS(2339): Property 'kioskAttributes' does not exist on type ... Remove this comment to see the full error message
    kioskAttributes: company.kioskAttributes,
    // @ts-expect-error TS(2339): Property 'enabledEmployeesCount' does not exist on... Remove this comment to see the full error message
    enabledEmployeesCount: company.enabledEmployeesCount,
    // @ts-expect-error TS(2339): Property 'completedSurveysCount' does not exist on... Remove this comment to see the full error message
    completedSurveysCount: company.completedSurveysCount,
    // @ts-expect-error TS(2339): Property 'inProgressSurveysCount' does not exist o... Remove this comment to see the full error message
    inProgressSurveysCount: company.inProgressSurveysCount,
    // @ts-expect-error TS(2339): Property 'created' does not exist on type '{}'.
    createdAt: company.created ? new Date(company.created * 1000).toString() : undefined,
    // @ts-expect-error TS(2339): Property 'updated' does not exist on type '{}'.
    updatedAt: company.updated ? new Date(company.updated * 1000).toString() : undefined,
    companyFeatureSettings: company.companyFeatureSettings,
    hasSso: company.hasSso ?? false,
  };

  return transformedCompany;
};

/**
 * Create "company" entities for the front-end, appending virtual values that
 * can be calculated up-front, here.
 *
 * @example kioskConfig (from server)
 * {
 *   id: 4
 *   kioskAttributeId: '88',
 *   kioskAttributes: [
 *     {
 *       id: 123,
 *       name: 'Employee Id'
 *     }
 *   ],
 *   kioskId: 'ccae6687-0ef6-4e35-ad03-3fb2500f5e56',
 *   kioskSubdomain: 'worktangoqa'
 * }
 */
const companyFromKiosk = (company = {}) => {
  return {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    id: Number(company.id),
    // @ts-expect-error TS(2339): Property 'kioskId' does not exist on type '{}'.
    kioskId: company.kioskId,
    // @ts-expect-error TS(2339): Property 'kioskAttributeId' does not exist on type... Remove this comment to see the full error message
    kioskAttributeId: company.kioskAttributeId === null ? null : Number(company.kioskAttributeId),
    // @ts-expect-error TS(2339): Property 'kioskSubdomain' does not exist on type '... Remove this comment to see the full error message
    kioskSubdomain: company.kioskSubdomain,
    // @ts-expect-error TS(2339): Property 'kioskAttributes' does not exist on type ... Remove this comment to see the full error message
    kioskAttributes: company.kioskAttributes,
    kioskLanguage: company.kioskLanguage,
  };
};

const companiesFrom = (companyList = []) => {
  return companyList.map((company) => companyFrom(company));
};

export { companyFrom, companyFromKiosk, companiesFrom, supportedLanguagesFrom };
